import { ChartOptions } from "../../config/type/chart-options";
import { createPluginOptions } from "../create-plugin-options";

export const defaultCommentBarOptions = createPluginOptions<ChartOptions>()({
	axes: {
		bottom: {
			grid: false,
		},
		left: {
			grid: true,
		},
	},
	period: 5,
	alignPeriod: false,
	openDialogOnClick: true,
});

export type CommentBarOptions = typeof defaultCommentBarOptions;
